import { authenticated } from './WebRequest';
import type {
  ApiThunk,
  Cansize,
  ColourCard,
  Colorant,
  Comment,
  DatabaseOverview,
  InitZoneBundle,
  Language,
  Product,
  ProductGroup,
  Site,
  Unit,
  Zone,
} from './types/Cache';

export type {
  AbstractBase,
  Advertisement,
  ApiThunk,
  BaseColorantRule,
  Cansize,
  ColourCard,
  Colorant,
  ColorantBatchInfo,
  ColorantCan,
  Comment,
  DatabaseOverview,
  InitZoneBundle,
  JsonPrimitive,
  JsonValue,
  Language,
  LocalClient,
  Nullable,
  OfflineDbData,
  Product,
  ProductBaseColorant,
  ProductBasePaint,
  ProductCan,
  ProductGroup,
  ProductGroupProduct,
  Site,
  Unit,
  Zone,
} from './types/Cache';

export default class CacheAPI {
  static loadZones(): ApiThunk<Zone[]> {
    return authenticated.get<Zone[]>('/auth/zone/');
  }

  static loadSites(replicationgroup: string): ApiThunk<Site[]> {
    return authenticated.get<Site[]>(
      `/rest/site/?replicationgroup=${replicationgroup}`
    );
  }

  static loadInitZoneBundle(
    zoneid: number,
    siteid: number,
    systemgroupid: number
  ): ApiThunk<InitZoneBundle> {
    return authenticated.get<InitZoneBundle>(
      `/bundle/systemgroup/${systemgroupid}/zone/${zoneid}/site/${siteid}/init_zone`
    );
  }

  static loadProducts(
    zoneid: number,
    siteid?: number,
    systemgroupid?: number
  ): ApiThunk<Product[]> {
    if (siteid !== undefined) {
      return authenticated.get<Product[]>(
        `/query/systemgroup/${systemgroupid}/zone/${zoneid}/site/${siteid}/products_list`
      );
    }
    return authenticated.get<Product[]>(
      '/query/zone/' + zoneid + '/products_list'
    );
  }

  static loadProductGroups(zoneid: number): ApiThunk<ProductGroup[]> {
    return authenticated.get<ProductGroup[]>(
      `/query/zone/${zoneid}/product_groups`
    );
  }

  static loadDatabaseOverview(
    zoneid: number,
    siteid: number,
    systemgroupid: number
  ): ApiThunk<DatabaseOverview> {
    return authenticated.get<DatabaseOverview>(
      `/query/systemgroup/${systemgroupid}/zone/${zoneid}/site/${siteid}/database_overview`
    );
  }

  static loadCards(zoneid: number): ApiThunk<ColourCard[]> {
    return authenticated.get<ColourCard[]>(
      '/query/zone/' + zoneid + '/cards_list'
    );
  }

  static loadCanSizes(): ApiThunk<Cansize[]> {
    return authenticated.get<Cansize[]>('/query/cansizes_list');
  }

  static loadUnits(): ApiThunk<Unit[]> {
    return authenticated.get<Unit[]>('/rest/unit/');
  }

  static loadColorants(zoneid: number): ApiThunk<Colorant[]> {
    return authenticated.get<Colorant[]>(
      '/query/zone/' + zoneid + '/colorants_list/'
    );
  }

  static loadLanguages(): ApiThunk<Language[]> {
    return authenticated.get<Language[]>('/translations/languages/');
  }

  static loadCommentsList(zoneid: number): ApiThunk<Comment[]> {
    return authenticated.get<Comment[]>(`/query/zone/${zoneid}/comments_list`);
  }
}
